import React, { Component } from 'react';
import { Button } from '@material-ui/core';
import SQLogo from '../../img/SelfQueryLogo.png';

class LicenseComponent extends Component {

  render() {
    return (
      <div style={{height: '100vh', display: 'flex', flexDirection:'column', justifyContent: 'center'}}>
        <img src={SQLogo} style={{width: '350px', margin: '0 auto'}} alt="SQ Logo"></img>
        <h1 style={{textAlign:'center', color:'#25265d'}}>Licencia expirada</h1>
        <p style={{textAlign:'center', color:'#25265d'}}>Por favor contacte al administrador para solicitar acceso</p>
        <div  style={{display: 'flex', justifyContent: 'center'}}>
          <Button color="primary" variant="contained" onClick={() => { this.props.history.push('/#/search') }}>
              Volver a ingresar
          </Button>
        </div>
      </div>
    );
  }
}

export default LicenseComponent;
